/**
 * ChatBI API 响应的 Zod 运行时校验 Schema
 *
 * 校验范围：执行计划确认/取消响应、任务取消响应、附件上传响应
 * 说明：ChatBI 的核心流式数据（SSE）在前端解析时已做 JSON.parse + 类型断言，
 *       此处仅覆盖 REST 接口的结构化响应。
 */
import { z } from 'zod'

/**
 * 执行计划确认/取消响应 Schema
 * 对应 src/api/chatbi.ts 的 PlanConfirmResponse 接口
 */
export const PlanConfirmResponseSchema = z.object({
  success: z.boolean(),
  plan_id: z.string(),
  action: z.string(),
  message: z.string(),
})

export type PlanConfirmResponseFromSchema = z.infer<typeof PlanConfirmResponseSchema>

/**
 * 任务取消响应 Schema
 * 对应 src/api/chatbi.ts 的 ChatCancelResponse 接口
 */
export const ChatCancelResponseSchema = z.object({
  task_id: z.string().nullable(),
  session_id: z.string(),
  cancelled: z.boolean(),
  message: z.string(),
})

export type ChatCancelResponseFromSchema = z.infer<typeof ChatCancelResponseSchema>

/**
 * 附件上传响应 Schema
 * 对应 src/api/chatbi.ts 的 UploadResponse 接口
 */
export const UploadResponseSchema = z.object({
  success: z.boolean(),
  url: z.string(),
  filename: z.string(),
  type: z.string(),
  size: z.number(),
  oss_key: z.string(),
})

export type UploadResponseFromSchema = z.infer<typeof UploadResponseSchema>
